import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "stack-vertical-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "none", stroke: "currentColor", d: "M12.5 13.5h-8a2 2 0 1 1 0-4h8a2 2 0 1 1 0 4Zm0-6h-8a2 2 0 1 1 0-4h8a2 2 0 1 1 0 4Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
